import { define } from 'wicked-elements'
import GenericSlideshow from '../lib/generic-slideshow'
import onIntersect from 'on-intersect'

define('[data-component="cycle"]', {
  init() {
    this.interval = null
    this.speed = this.element.getAttribute('data-speed') || 1500
    // this.$nav = this.element.querySelector('[data-cycle-navigation]')
    // this.$navItems = this.$nav ? [...this.$nav.children] : []
    this.$index = this.element.querySelector('[data-cycle-index]')

    this.slideshow = GenericSlideshow(this.element, {
      slides: this.element.querySelectorAll('figure'),
      onChange: slides => this.onChange(slides)
    }).init()

    this.play = this.play.bind(this)
    this.pause = this.pause.bind(this)
  },
  connected() {
    this.stopObserving = onIntersect(this.element, {}, this.play, this.pause)
    // this.element.addEventListener('mouseenter', this.pause)
    // this.element.addEventListener('mouseleave', this.play)
  },
  disconnected () {
    this.stopObserving()
    // this.element.removeEventListener('mouseenter', this.pause)
    // this.element.removeEventListener('mouseleave', this.play)
  },
  onChange ($slides) {
    var nextImage = $slides.next ? $slides.next.querySelector('img') : false
    if (nextImage) {
      nextImage.dispatchEvent(new CustomEvent('triggerLoad'))
    }
    // if (this.$navItems.length) {
    //   this.$navItems.forEach(i => i.classList.remove('active'))
    //   this.$navItems[$slides.index].classList.add('active')
    // }
    if (this.$index) {
      this.$index.innerHTML = $slides.index + 1
    }
  },
  play () {
    this.pause()
    this.interval = setInterval(() => {
      this.slideshow.next()
    }, this.speed)
  },
  pause () {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }
})